import { Panel } from "components/panels";
import React from "react";
import VersionRows from "./VersionRows";
import CollapsibleSection from "components/DetailPage/CollapsibleSection";
import DatabaseRows from "./DatabaseRows";
import CdnRows from "./CdnRows";
import RedisRows from "./RedisRows";
import ExchangeRateRows from "./ExchangeRateRows";
import GeocodeRows from "./GeocodeRows";
import VatNumberRows from "./VatNumberRows";
import UserTaskRows from "./UserTaskRows";
import DerTicketServiceRows from "./DerTicketServiceRows";

interface Props {
  config: server.dto.DashboardAdminOneHealthPanelConfig
}

const HealthPanel = ({ config }: Props) => {
  return <Panel
    title={config.headerLabel}
    panelClassName="s1_dashboard-panel"
    contentCssClass="flex-column gap-larger"
  >
    <CollapsibleSection title="Version" collapsible="startOpen" uniqueRowId="adminOneVersionRows">
      <VersionRows version={config.version} />
    </CollapsibleSection>

    <CollapsibleSection title="Database" collapsible="startOpen" uniqueRowId="adminOneDatabaseRows">
      <DatabaseRows sql={config.sql} />
    </CollapsibleSection>

    <CollapsibleSection title="Cdns" collapsible="startOpen" uniqueRowId="adminOneAzureStorageRows">
      <CdnRows azureStorage={config.azureStorage} serverCdn={config.serverCdn} />
    </CollapsibleSection>

    <CollapsibleSection title="Redis" collapsible="startOpen" uniqueRowId="adminOneRedisRows">
      <RedisRows redis={config.redis} />
    </CollapsibleSection>

    <CollapsibleSection title="Exchange rate" collapsible="startOpen" uniqueRowId="adminOneExchangeRateRows">
      <ExchangeRateRows exchangeRate={config.exchangeRate} />
    </CollapsibleSection>

    <CollapsibleSection title="DerTicketService" collapsible="startOpen" uniqueRowId="derTicketService">
      <DerTicketServiceRows derTicketService={config.derTicketService} />
    </CollapsibleSection>

    <CollapsibleSection title="Geo code" collapsible="startOpen" uniqueRowId="adminOneGeoCodeRows">
      <GeocodeRows />
    </CollapsibleSection>

    <CollapsibleSection title="Company VAT number" collapsible="startOpen" uniqueRowId="adminOneCompanyVatNumber">
      <VatNumberRows />
    </CollapsibleSection>

    <CollapsibleSection title="User tasks" collapsible="startOpen" uniqueRowId="adminOneUserTasks">
      <UserTaskRows />
    </CollapsibleSection>
  </Panel>;
};

export default HealthPanel;